<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form #form [form]="formIdSearch">
        </sm-form>
        <p-button icon="fas fa-run" label="Starten" (onClick)="searchId()"></p-button>
    </p-panel>
    <div class="flex-item-fill">
        <p-message *ngIf="anythingFound === false" severity="warning" text="Es wurden keine Ergebnisse gefunden"></p-message>
        <p-panel  *ngIf="tableDataIdSearchUsers != null" header="Benutzer">
            <sm-table2 [data]="tableDataIdSearchUsers" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchOrganisations != null" header="Organisationen">
            <sm-table2 [data]="tableDataIdSearchOrganisations" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchOrgObjects != null" header="Organisationsobjekte">
            <sm-table2 [data]="tableDataIdSearchOrgObjects" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchWfFamilies != null" header="Workflowfamilien">
            <sm-table2 [data]="tableDataIdSearchWfFamilies" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchWfModels != null" header="Workflowmodelle">
            <sm-table2 [data]="tableDataIdSearchWfModels" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchProcesses != null" header="Workflows">
            <sm-table2 [data]="tableDataIdSearchProcesses" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchObjectTypes != null" header="Objekttypen">
            <sm-table2 [data]="tableDataIdSearchObjectTypes" [autoHeight]=true></sm-table2>
        </p-panel>
        <p-panel  *ngIf="tableDataIdSearchFields != null" header="Felder">
            <sm-table2 [data]="tableDataIdSearchFields" [autoHeight]=true></sm-table2>
        </p-panel>
    </div>
</div>
